<template>
  <LandingPage />
</template>

<script setup lang="ts">
import LandingPage from './LandingPage.vue'
</script>

<style>
/* Global styles are imported in main.ts */
</style> 